/**
 * Visualization kinds that need their own instance implementation. Native GLSL is built in;
 * ISF and Butterchurn register here.
 */
import { ButterchurnViz } from '../butterchurn/ButterchurnViz';
import { IsfViz } from '../isf/IsfViz';
import type { KindInstaller } from '../Renderer';

export const KIND_INSTALLERS: KindInstaller[] = [
  (registry, { gl, cache }) => registry.registerKind('isf', (def) => new IsfViz(gl, cache, def)),
  (registry, { gl, cache }) =>
    registry.registerKind('butterchurn', (def) => new ButterchurnViz(gl, cache, def)),
];
